import Cookies from 'js-cookie';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { SEEN_CPD_LANDING } from '../../constants/cookies';
import { selectCpdNewIndicatorVisible } from '../../reducers/cpd/selectCpdNewIndicatorVisible';

export const useCpdNewIndicator = () => {
  const isNewCpdIndicatorVisible = useSelector(selectCpdNewIndicatorVisible);
  const [seenLanding, setSeenLanding] = React.useState(true);

  React.useEffect(() => {
    setSeenLanding(Cookies.get(SEEN_CPD_LANDING) === '1');
  }, []);

  const showIndicator = isNewCpdIndicatorVisible && !seenLanding;

  return { showIndicator };
};
